import React, { useState } from 'react'

import {
  Icon, TextInput, VisibilityOff, VisibilityOn,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function PasswordField({ value, onChange }) {
  const [showPassword, setShowPassword] = useState(false)
  const t = useTranslation()

  const handleToggleVisibility = () => {
    setShowPassword(current => !current)
  }

  return (
    <TextInput
      id="ai-sign-in-password"
      name="password"
      inputType={showPassword ? 'text' : 'password'}
      size="medium"
      label={t('signIn.password.passwordLabel')}
      value={value}
      onChange={onChange}
      wrapperClassName="ai-sign-in-modal__field"
      autoComplete="current-password"
      isPilot
      trailIcon={(
        <Icon
          svgComponent={showPassword ? VisibilityOff : VisibilityOn}
          color="dark"
          withHover
          onClick={handleToggleVisibility}
          aria-label={t(showPassword ? 'signIn.password.hidePassword' : 'signIn.password.showPassword')}
        />
      )}
    />
  )
}

PasswordField.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
}

export default PasswordField
